import { motion } from 'framer-motion';
import { fadeUp } from '../../utils/animations';

export function PullQuote() {
    return (
        <section className="bg-navy-900 py-24 md:py-32" data-testid="pull-quote">
            <div className="max-w-3xl mx-auto px-6 lg:px-12 text-center">
                <motion.div {...fadeUp}>
                    <div className="w-12 h-0.5 bg-gold-400 mx-auto mb-8" />
                    <p className="font-montserrat text-2xl md:text-3xl text-white leading-relaxed italic font-medium mb-6">
                        "If you're looking for cheap labor, this is not the model. If you're looking for leverage, continuity, and reduced risk - this is what it was built for."
                    </p>
                    <p className="text-gold-400 text-sm font-bold tracking-[0.2em] uppercase font-inter">
                        Adam Cothes, Founder
                    </p>
                </motion.div>
            </div>
        </section>
    );
}
